'use client';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiCall from '@/lib/apiCall';
import { extractApiError } from '@/lib/apiError';
import AlertBox from '@/components/layout/AlertBox';
import Botao from '@/components/Botao';
import { mdiArrowRight, mdiLoading } from '@mdi/js';

const MENSAGEM_INVALIDO = 'Este link já foi usado ou expirou. Peça um novo ao administrador.';

const Page = () => {
  const navigate = useNavigate();
  // Token no fragmento (#), não no path: o fragmento nunca sai do navegador —
  // não aparece no access log do nginx/Apache, em proxy corporativo nem no
  // header Referer. Lido uma vez e apagado da barra de endereço (replaceState
  // troca a entrada atual do histórico, então ele também sai do histórico).
  const [token] = useState<string | null>(() => {
    const valor = decodeURIComponent(window.location.hash.replace(/^#/, '')).trim();
    if (valor) {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }
    return valor || null;
  });
  const [erro, setErro] = useState<string | null>(token ? null : 'Link de acesso inválido.');
  const [entrando, setEntrando] = useState(false);

  // Consumo só dispara com um clique explícito do usuário, nunca no mount:
  // scanners de link (preview do WhatsApp, Outlook Safe Links, proxy
  // corporativo) fazem GET automático nesta URL — se o POST saísse sozinho
  // no useEffect, esse GET automático já queimaria o token antes de qualquer
  // pessoa real clicar.
  const handleEntrar = async () => {
    if (!token || entrando) return;
    setEntrando(true);
    setErro(null);

    try {
      const result = await ApiCall.post('/api/login/token', { token });
      if (result.ok) navigate('/', { replace: true });
      else {
        setErro(MENSAGEM_INVALIDO);
        setEntrando(false);
      }
    } catch (err) {
      const { message } = extractApiError(err, MENSAGEM_INVALIDO);
      setErro(message);
      setEntrando(false);
    }
  };

  return (
    <div style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ textAlign: 'center', maxWidth: '380px' }}>
        <img src="/logo192.png" alt="Logo WebIP" style={{ height: '56px', marginBottom: '24px' }} />

        {erro ? (
          <>
            <AlertBox variant="danger">{erro}</AlertBox>
            <p style={{ marginTop: '16px' }}>
              <a href="/login">Ir para o login</a>
            </p>
          </>
        ) : (
          <>
            <p style={{ color: 'var(--color-muted)', marginBottom: '20px' }}>
              Você recebeu um link de acesso único. Clique abaixo para entrar — ele vale apenas uma vez.
            </p>
            <Botao
              variant="primary"
              onClick={handleEntrar}
              disabled={entrando}
              icon={entrando ? mdiLoading : mdiArrowRight}
              iconProps={entrando ? { spin: true } : undefined}
            >
              {entrando ? 'Entrando...' : 'Entrar'}
            </Botao>
          </>
        )}
      </div>
    </div>
  );
};

export default Page;
